module.exports = __webpack_public_path__ + "img/logo-login.083093e2.png";